import axios from 'axios';
import { ApibaceUrl } from '../Constants/Constants';
const instance = axios.create({
    baseURL:ApibaceUrl,
  
  });

  export default instance;